import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MerchantViewModel } from "../models/merchant-view-model";
import { MerchantService } from "../services/merchant.service";
import { MerchantDTViewModel } from "../models/merchant-dt-view-model";
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionEnum, AccessPolicyEnum } from "../services/guards/permissions";
import { AuthenticationService } from "../services/authentication.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponseViewModel } from '../models/data-tables-response-view-model';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-merchant-audit',
  templateUrl: './merchant-audit.component.html',
  styleUrls: ['./merchant-audit.component.scss']
})

export class MerchantAuditComponent implements OnInit {
  public dtTrigger: Subject<boolean> = new Subject();
  public merchants: MerchantDTViewModel[] = [];

  public searchDebounce = new Subject<string>();

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  merchantNumber: string;

  public nameLocationSearch = '';
  public merchantIdSearch = '';

  public canView = false;
  public ViewButtonStyle: string;
  constructor(private _httpClient: HttpClient,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _merchantService: MerchantService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService) {


    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantAudit], []);
    if (!this.canView) {
      this.ViewButtonStyle = "display: none";
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
      this._ngxUiLoaderService.stop();
      this.ngOnDestroy();
    }

    this.searchDebounce.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(async value => {
        await this.refreshTable();
      });

  }
  ngOnInit() {

  }


  public async ngAfterViewInit(): Promise<void> {

    this.dtTrigger.next();
    //await this.init();

  }

  private async init(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.merchants = await this._merchantService.GetAllMerchants();

    if (this.merchants.length > 0) {
      this.dtTrigger.next();
    }

    this._ngxUiLoaderService.stop();
  }

  private resetDatatable(): void {

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });

  }

  public async viewMerchant(merchant: MerchantViewModel): Promise<void> {
    this._router.navigate(['management', 'audit-merchant', merchant.merchantNumber]);
  }

  private async refreshTable(): Promise<void> {
    await this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }

  public columns: any[] = [

    { data: 'merchantNumber', title: 'Merchant Id', visible: true, searchable: true, search: { value: this.merchantIdSearch, regex: true } },
    { data: 'nameLocation', title: 'Location', visible: true, searchable: true, search: { value: this.nameLocationSearch, regex: true } },
  ];

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          `${environment.apiUrl}/api/merchant/Search`,
          dataTablesParameters, {}
        ).subscribe(resp => {

          this.merchants = resp.data;

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns

  };

  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
